import React from "react";

import ContentCardList from "../../../Components/ContentCardList/ContentCardList";
import PageHeader from "../../../Components/PageHeader/PageHeader";
import FavoritesPageSkeleton from "./FavoritesPageSkeleton";
import useFavorites from "../../../hooks/PortalAluno/useFavorites";
import "./styles.css";

const getErrorMessage = (error: unknown) =>
  error instanceof Error && error.message && error.message !== "Network Error"
    ? error.message
    : "Não foi possível carregar os favoritos. Verifique sua conexão e tente novamente.";

const FavoritesPage = () => {
  const { data, error, isError, isLoading, refetch } = useFavorites();

  if (isLoading) return <FavoritesPageSkeleton />;

  if (isError && !data) {
    return (
      <section className="content-page favorites-page" aria-label="Favoritos">
        <div className="favorites-page__feedback" role="alert">
          <h1>Não foi possível abrir os Favoritos</h1>
          <p>{getErrorMessage(error)}</p>
          <button type="button" onClick={() => refetch()}>
            Tentar novamente
          </button>
        </div>
      </section>
    );
  }

  const cards = data?.cards ?? [];

  return (
    <section className="content-page favorites-page" aria-label="Favoritos">
      <PageHeader
        title="Favoritos"
        description="Os conteúdos que você salvou ficam reunidos aqui para rever quando quiser."
      />

      <ContentCardList
        title="Conteúdos salvos"
        cards={cards}
        saved
      />
    </section>
  );
};

export default FavoritesPage;
